<template>
  <section>
    <div class="custom-file-wrapper">
      <ul class="custom-file-list">
        <li v-for="item of attachments" :key="item.blogAttachment">
          <div class="row custom-file-record">
            <div class="col-1">
              <a :href="item.fileUrl" target="_blank">link</a>
            </div>
            <div class="col-6">
              <span>{{ item.filename }}</span>
            </div>
            <div class="col"></div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { blogStore } from '@/stores/blog'
export default {
  name: 'BlogAttachments',
  props: {
    blog: Object
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState(blogStore, ['attachments'])
  },
  methods: {
    ...mapActions(blogStore, ['getAttachments']),
    async init() {
      await this.getAttachments({
        blog: this.blog.blog,
        blogComment: null
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-file-wrapper {
  margin-top: 10px;
  height: 100px;
  max-height: 100px;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  border: 1px solid #ced4da;
}
.custom-file-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
}
.custom-file-record {
  padding-top: 5px;
  padding-bottom: 5px;
  margin-right: 15px;
  margin-left: 15px;
}
</style>
